import React from "react";
import { changeEditingCombatantValue, getSafeCombatantName } from "./edit-combatant-operations";

class EditCombatantNameField extends React.Component {
  handleInputChange() {
    changeEditingCombatantValue(
      "combatantName",
      this.refs.input.value
    );
  }

  handleInputFocus() {
    //Auto select the whole thing when focusing.
    this.refs.input.setSelectionRange(0, this.refs.input.value.length);
  }

  handleSubmit(e) {
    e.preventDefault();

    //Get a clean version of the final name
    const safeName = getSafeCombatantName(this.refs.input.value.trim());
    changeEditingCombatantValue("combatantName", safeName);

    this.refs.input.blur();
  }

  render() {
    const groupStyle = {
      marginBottom: "2em"
    };
    return (
      <div style={groupStyle}>
        {/*<label style={labelStyle}>Name</label>*/}
        <form onSubmit={this.handleSubmit.bind(this)}>
          <input
            name="Name"
            onFocus={this.handleInputFocus.bind(this)}
            className="NameTextInput"
            style={{
              textTransform: "uppercase",
              fontSize: "1em"
            }}
            onChange={this.handleInputChange.bind(this)}
            ref="input"
            value={this.props.combatantName}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            maxLength={9}
          />
        </form>
      </div>
    );
  }
}

export default EditCombatantNameField;



// WEBPACK FOOTER //
// ./src/b5-crew-management/EditCombatantNameField.js